var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgGalleryColorfull = function SvgGalleryColorfull(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.31 6.547A22.437 22.437 0 0022.444 0v22.34L38.31 6.547z",
    fill: "#AD44CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.444 22.34h22.444c0-6.182-2.513-11.746-6.578-15.793L22.444 22.34z",
    fill: "#8432A4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.444 22.34L6.578 38.132a22.387 22.387 0 0015.866 6.547V22.34z",
    fill: "#CE65DE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 22.34c0 6.182 2.513 11.746 6.578 15.792L22.444 22.34H0z",
    fill: "#9B37A3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.444 22.34v22.34c12.393 0 22.444-10.004 22.444-22.34H22.444zM6.578 6.547C2.513 10.594 0 16.157 0 22.34h22.444V0c-6.211 0-11.8 2.5-15.866 6.547z",
    fill: "#6B39A0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.824 15.37h-12.76a2.302 2.302 0 00-2.315 2.305v9.301a2.302 2.302 0 002.315 2.304h12.732a2.302 2.302 0 002.315-2.304v-9.3c.028-1.265-1.017-2.305-2.287-2.305z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.419 20.541c.717 0 1.298-.578 1.298-1.292 0-.714-.581-1.293-1.298-1.293-.718 0-1.299.579-1.299 1.293s.581 1.292 1.299 1.292zm5.251 2.669l-1.497-1.657-2.145 2.248-1.75 1.517-1.3-.899v2.613h12.93v-3.034l-3.387-3.738-2.851 2.95z",
    fill: "#6B39A0"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGalleryColorfull);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "flash-chat-assets/galleryColorfull.476c54fe.svg";